import DatabaseModel from './DatabaseModel.js';

var EvaluadorJS = Object.create(DatabaseModel);

EvaluadorJS.model = 'core/evaluadorjs';
EvaluadorJS.modelFront = 'evaluadorjs';

export default EvaluadorJS;